import InfoIcon from '@mui/icons-material/Info'; // Or any other icon you want to use
import { alpha, Box, Grid, Pagination, PaginationItem, Paper, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import 'react-grid-layout/css/styles.css';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import ButtonVitec from '../../../app/components/ButtonVitec';
import ToolTipTfWrapper from '../../../app/components/ToolTipTfWrapper';
import Utils from '../../../felles/Utils';
import { default as NV05 } from '../../../models/NV05';
import PageImpl from '../../../models/PageImpl';
import NV05FormListData from '../../../models/payload/NV05FormListData';
import * as actions from '../../../store/actions/index';
import * as actionsNV05 from '../../../store/actions/indexNV05';
import { AppState } from '../../../store/rootReducer';
import { useStyles } from '../styles/List.styles';
import NV05TableHead, { hInit } from './NV05TableHead';
import { TableHeaders } from '../../../models/Headers';


const tooltipContent = (
  <Box>
    {/* Section 1 */}
    <Box sx={{ padding: "5px", fontWeight: "bold" }}>Programmet viser en kombinasjon av fakturerte ordre og åpne ordre.</Box>
    <Typography variant="body2" sx={{ padding: "5px" }}>
      <strong>Salg denne måneden:</strong><br />
      Sett inn første siffer i varegruppe for å få utplukk
      av ønsket varegruppe.<br />
      Alle varene kommer opp om siffer ikke settes inn.<br /><br />
      <strong>Salg hittil i år:</strong><br />
      Fakturerte ordre hittil i år + åpne ordre inneværende mnd.<br /><br />

      <strong>Salg hittil i fjor:</strong><br />
      Fakturerte ordre for i fjor. Vises for hele mnd.<br />

      <br />
      Kreditnotaer med annen kode enn 2 – retur av varer er ikke med i beregningen.
      Ordre med edb-nummer som går til minus (995 eller 994) vises som pluss-salg og ikke minus.
    </Typography>
  </Box>
);

interface NV05PERSONFormHookProps {
  // size: { readonly width: number | null; readonly height: number | null; };
}


const NV05List: React.FC = () => {
  const { classes: cls } = useStyles();  // Accessing styles
  const dispatch = useDispatch();  // Redux dispatch
  const page: PageImpl<NV05> = useSelector((state) => (state as AppState).NV05.page);
  const [defaultPageCount, setDefaultPageCount] = useState(10);
  const tableHeaders: TableHeaders[] = useSelector((state) => (state as AppState).NV05.tableHeaders);
  const [currentFocusedField, setCurrentFocusedField] = useState('');
  const isLoading: boolean = useSelector((state) => (state as AppState).utils.isLoading);
  const currentRowFocused: number = useSelector((state) => (state as AppState).NV05.currentRowFocused);
  const scrollTopPosition: number = useSelector((state) => (state as AppState).NV05.scrollTopPosition);
  const tableContainerRef = useRef<HTMLDivElement>(null); // Ref for the scrollable container

  // Redux state for key pressed. -1 enable keys on this component, 0 disable keys on this component and enable keys on subcomponent.
  const stateKeypressed: number = useSelector((state) => (state as AppState).NV05.stateKeypressed);


  const methods = useForm<NV05FormListData>({
    defaultValues: { companyId: Utils.T_companyNr, search: '', pageSize: 100, sort: '', exportToExcel: false, tableHeaders: [], page: 0 },
  });

  {/* --------------------------------------- Effects ------------------------------------- */ }
  useEffect(() => {
    if (!isLoading)
      onSubmit(methods.getValues()); // Reset the form state when the component mounts
    // NettbrettNETTBRETT hack - Prevent default touchmove behavior
    window.addEventListener('keydown', handleKeyUpPressedAtWindowDocumentLevel);
    // Get the table container
    const tableContainer = tableContainerRef.current;
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('keydown', handleKeyUpPressedAtWindowDocumentLevel);
      //
    };
  }, [stateKeypressed]);


  useEffect(() => {
    // NettbrettNETTBRETT hack - Remove event listeners on component unmount
    document.body.removeEventListener('touchmove', Utils.preventDefault);

    // Set default page count based on content
    page.content?.length > 0 ? setDefaultPageCount(page.totalPages) : setDefaultPageCount(10);

    // Reset sandwich button state on load
    dispatch(actions.setSandwichButtonStateClicked(false));

    // Automatically focus on the first input field (alfa) when the component mounts
    if (currentFocusedField === '' && page.content?.length == 0) {
      const inputField: HTMLInputElement | null = document.querySelector('input[name="search"]');
      if (inputField && inputField.value === '') {
        inputField.focus();
      }
    }
    // Load column headers if not already loaded
    if (tableHeaders.length === 0) {
      dispatch(actionsNV05.NV05UpdateColumnHeaderList(hInit));
    }
    // Add event listeners for keyboard shortcuts
    document.addEventListener('keydown', handleKeyUpPressedAtDocumentLevel);

    return () => {
      // Remove event listeners for keyboard shortcuts
      document.removeEventListener('keydown', handleKeyUpPressedAtDocumentLevel);
    };
  }, [page.content, tableHeaders, isLoading, currentRowFocused, currentFocusedField, dispatch]);


  const handleKeyUpPressedAtWindowDocumentLevel = (event: KeyboardEvent | React.KeyboardEvent<HTMLDivElement>) => {
    const { key } = event;
    const actionSource = key || (event.target && (event.target as HTMLInputElement).value);
    //
    if (key === 'Home' || key === 'F7' || key === 'F8') {
      event.preventDefault();
      const index = page.content.findIndex(item => +item.productGroup === currentRowFocused);
      switch (true) {
        // F7 navigates to the previous page
        case actionSource === 'F7':
          if (methods.getValues('page') >= 1) {
            methods.setValue('page', methods.getValues('page') - 1)
            methods.handleSubmit(onSubmit)();
          }
          break;
        // F8 navigates to the next page
        case actionSource === 'F8':
          if (methods.getValues('page') < defaultPageCount - 1) {
            methods.setValue('page', methods.getValues('page') + 1)
            methods.handleSubmit(onSubmit)();
          }
          break;
        // Reset button resets the form and data
        case actionSource === 'F9': {
          // Reset the form state
          methods.reset();
          // Reset the child component state
          dispatch(actionsNV05.NV05ResetForm(true));
          // Focus on the first input field (alfa) after reset
          const inputField: HTMLInputElement | null = document.querySelector('input[name="alfaKode"]');
          if (inputField && inputField.value === '') {
            inputField.focus();
          }
          break;
        }
      }
    }
  }

  const handleKeyUpPressedAtDocumentLevel = (event: KeyboardEvent | React.KeyboardEvent<HTMLDivElement>) => {
    const { key } = event;
    const actionSource = key || (event.target && (event.target as HTMLInputElement).value);
    const index = page.content.findIndex(item => +item.productGroup === currentRowFocused);

    Utils.log('handleKeyUpPressedAtDocumentLevel', actionSource, 'currentRowFocused:', currentFocusedField, 'index:', index, 'page.content.length:', page.content.length);
    Utils.log('currentRowFocused', currentFocusedField, 'stateKeypressed', stateKeypressed);

    /**
     * Scrolls the table container to make the selected row visible
     * 
     * Calculates the optimal scroll position to center the selected row
     * in the visible area of the table container.
     * 
     * @param {number} rowIndex - The index of the row to scroll to
     */
    const scrollToRow = (rowIndex: number, $rowHeight: number, $headerHeight: number) => {
      if (tableContainerRef.current && rowIndex >= 0) {
        // Calculate row height (assuming consistent row height)
        const rowHeight = $rowHeight; // Approximate height of each table row
        const headerHeight = $headerHeight; // Height of table header
        const containerHeight = tableContainerRef.current.clientHeight;

        // Calculate the position of the target row
        const rowTop = headerHeight + (rowIndex * rowHeight);
        const rowBottom = rowTop + rowHeight;

        // Get current scroll position
        const currentScrollTop = tableContainerRef.current.scrollTop;
        const visibleTop = currentScrollTop;
        const visibleBottom = currentScrollTop + containerHeight;

        // Check if row is already visible
        if (rowTop < visibleTop) {
          // Row is above visible area, scroll up
          tableContainerRef.current.scrollTo({
            top: rowTop - headerHeight - 10, // Add small offset
            behavior: 'smooth'
          });
        } else if (rowBottom > visibleBottom) {
          // Row is below visible area, scroll down
          tableContainerRef.current.scrollTo({
            top: rowBottom - containerHeight + 10, // Add small offset
            behavior: 'smooth'
          });
        }
        // If row is already visible, no scrolling needed
      }
    };
  };


  const handleKeyPress = (event: React.KeyboardEvent<HTMLFormElement>) => {
    // Get the key pressed
    const { key } = event;
    const actionSource = key || (event.target && (event.target as HTMLInputElement).value);

    event.preventDefault();
    //setKey
    switch (true) {
      // Enter submits the form
      // Enter submits the form
      case (actionSource === 'Enter'):
        methods.setValue('tableHeaders', hInit);
        dispatch(actionsNV05.NV05UpdateColumnHeaderList(hInit));
        methods.setValue('exportToExcel', false);
        methods.setValue('page', 0)
        methods.handleSubmit(onSubmit)();
        break;

      case (actionSource === 'Export'):
        actionSource === 'Export' ? methods.setValue('exportToExcel', true) : methods.setValue('exportToExcel', false);
        methods.setValue('page', 0)
        methods.handleSubmit(onSubmit)();
        break;
      // Reset button resets the form and data
      case actionSource === 'Reset': {
        // Reset the form state
        methods.reset();
        // setIsHentDisabled(true);
        // Reset the child component state
        dispatch(actionsNV05.NV05ResetForm(true));
        // Focus on the first input field (alfa) after reset
        const inputField: HTMLInputElement | null = document.querySelector('input[name="alfaKode"]');
        if (inputField && inputField.value === '') {
          inputField.focus();
        }
        break;
      }
      default:
        return;
    }
  };


  // Function to handle form submission
  const onSubmit = (data: any) => {

    methods.setValue('companyId', Utils.T_companyNr);
    if (data.tableHeaders.length === 0) {
      data.tableHeaders = hInit;
    }
    // Check if the form is in loading state and prevent multiple submissions
    if (!isLoading) {
      dispatch(actionsNV05.NV05ListeGet(data));
      methods.setValue('exportToExcel', false);
      //Reset scroll position after data is dispatched
      //dispatch(actionsNV05.setScrollTopPosition(0));
    }
    // }
  };


  const pagechange = (e: any, pageValue = 0) => {
    methods.setValue('page', pageValue - 1)// offsetting by 1
    methods.handleSubmit(onSubmit)();
  };


  const setSort = (value: TableHeaders[]) => {
    methods.setValue('tableHeaders', value);
    methods.handleSubmit(onSubmit)();
  };


  const hasHearderListAFilterActive = (): boolean => {
    return tableHeaders.some((header) => header.filter !== '');
  };


  interface HandleSingleInsertProps {
    companyId?: string;
    search?: string;
    pageSize?: number;
    sort?: string;
    exportToExcel?: boolean;
    tableHeaders?: TableHeaders[];
    page?: number;
    [key: string]: any;
  }

  // Rendering the form and table
  return (
    <FormProvider {...methods}>
      <form className={cls.root} onKeyUp={handleKeyPress}>
        <input  {...methods.register("companyId")} hidden />
        <input  {...methods.register("page")} hidden />
        <input  {...methods.register("pageSize")} hidden />
        <input  {...methods.register("sort")} hidden />
        <input  {...methods.register("exportToExcel")} hidden />
        <Paper elevation={0} sx={{ backgroundColor: alpha('#fff', .6) }} >
          <TableContainer sx={{ borderRadius: '5px' }} >
            <Grid container width={'auto'} height={page.content.length > 0 ? (methods.watch('search') ? `calc(100vh - 83px)` : `calc(100vh - 122px)`) : 'auto'} style={{ maxHeight: '100vh' }}>
              {/* HEADER SECTION */}
              <Grid container height={'80px'} className={cls.ba} sx={{ width: '100%', paddingTop: 1 }} position="relative" >
                {/* Info Tooltip at top right */}
                <Box sx={{ position: 'absolute', top: '-4px', right: '6px', zIndex: 1 }}>
                  <Tooltip
                    title={<Typography variant="body2">{tooltipContent}</Typography>}
                    arrow
                    componentsProps={{
                      tooltip: {
                        sx: {
                          maxWidth: 800,
                          marginRight: 1,
                          fontSize: '14px'
                        }
                      }
                    }}
                  >
                    <InfoIcon style={{ cursor: "pointer", color: "#1d6f42" }} />
                  </Tooltip>
                </Box>
                <Grid container height={'10px'} alignItems="center" justifyContent='left' className={cls.bb} />
                <Grid container height={'40px'} className={cls.bb} direction="row"
                  justifyContent="space-between" alignItems="center" sx={{ width: '100%', paddingLeft: 2, paddingRight: 2 }}>
                  <Grid container direction="row" alignItems="flex-end" sx={{ width: 'auto', flex: '0 0 auto', gap: 2 }}>
                    <Grid sx={{ minWidth: '300px' }} >
                      <ToolTipTfWrapper id='talfa'
                        title={<div>Søkefelt for varegruppe.</div>}
                        placement={"top"} delay={8000}>
                        <TextField label="Varegruppe" autoComplete="off" className={cls.tField} inputProps={{ shrink: 'false' }}
                          {...methods.register("search", { required: false })}
                          onChange={(e) => {
                            methods.setValue('search', (e.target as any).value);
                          }}
                        />
                      </ToolTipTfWrapper>
                    </Grid>
                    <Grid>
                      <ButtonVitec _onclick={(e) => handleKeyPress({ key: 'Enter', target: e.target, preventDefault: () => e.preventDefault() } as React.KeyboardEvent<HTMLFormElement>)} _width={105} _height={37} _weight={600} _type={'button'}
                        _label={'Søk'} _value={'Enter'} _tooltip={'Klikk på knappen for å sende inn skjemaet, eller trykk Enter'} />
                    </Grid>
                    <Grid sx={{ paddingRight: '20px' }}>
                      <ButtonVitec _onclick={(e) => handleKeyPress({ key: 'Export', target: e.target, preventDefault: () => e.preventDefault() } as React.KeyboardEvent<HTMLFormElement>)} _width={105} _height={37} _type={'button'} _color={'green'}
                        _label={'EXCEL'} _value={'Export'} disabled={page.content.length === 0} />
                    </Grid>
                  </Grid>
                </Grid>
                {/* CHECKBOX SECTION */}
                <Grid container height={'5px'} alignItems="center" justifyContent='left' className={cls.bb} />
              </Grid>
              {/* CONTENT SECTION - Table */}
              <Grid container
                width={'100%'}
                height={page.content.length > 0 ? (methods.watch('search') ? `calc(100vh - 186px)` : `calc(100vh - 225px)`) : 'auto'}
                alignItems="top"
                justifyContent='center'
                className={cls.ba}
                ref={tableContainerRef}
                sx={{
                  maxHeight: '100vh', overflow: 'auto',
                  "&::-webkit-scrollbar-thumb": { backgroundColor: "#706c6a", },
                }}
              >
                {page.content.length > 0 || hasHearderListAFilterActive() ?
                  <Grid width={'100%'} >
                    <Table stickyHeader className={cls.table} size="small" aria-labelledby="tableTitle" >
                      <NV05TableHead onRequestSort={setSort} />
                      <TableBody sx={{ width: '100%' }}>
                        <TableRow
                          aria-checked={false}
                          key={9999}
                          selected={false}
                          sx={{
                            backgroundColor:
                              '#d8eff2', height: '35px',
                          }}
                        >
                          <TableCell className={cls.tC} ></TableCell>
                          <TableCell className={cls.tC} >TOTAL SALG:</TableCell>
                          <TableCell className={cls.tC} sx={{ width: '15%', textAlign: 'right !important' }}>{Utils.formatNumber(+page.totalMonthValue)}</TableCell>
                          <TableCell className={cls.tC} sx={{ width: '15%', textAlign: 'right !important' }}>{Utils.formatNumber(+page.totalYearValue)}</TableCell>
                          <TableCell className={cls.tC} sx={{ width: '15%', textAlign: 'right !important' }}>{Utils.formatNumber(+page.totalLastYearValue)}</TableCell>

                        </TableRow>

                        {
                          Array.isArray(page.content) && page.content?.length > 0 ? (
                            page.content.map((n: NV05, i: number) => (
                              <TableRow
                                aria-checked={false}
                                key={i}
                                selected={false}
                                sx={{
                                  backgroundColor:
                                    currentRowFocused == +n.productGroup ? '#d8eff2' : '#fff',
                                  border: '1px solid #fff',
                                  '&:hover': {
                                    backgroundColor: currentRowFocused == + n.productGroup ? '#d8eff2' : '#f3f3f3', // Change this to your desired hover color
                                  }
                                }}
                              >
                                <TableCell className={cls.tC} sx={{ width: '15%' }}>{n.productGroup}</TableCell>
                                <TableCell className={cls.tC} sx={{ width: '43%' }}>{n.name}</TableCell>
                                <TableCell className={cls.tC} sx={{ width: '14%', textAlign: 'right !important' }}>{Utils.formatNumber(+n.monthValue)}</TableCell>
                                <TableCell className={cls.tC} sx={{ width: '14%', textAlign: 'right !important' }}>{Utils.formatNumber(+n.yearValue)}</TableCell>
                                <TableCell className={cls.tC} sx={{ width: '14%', textAlign: 'right !important' }}>{Utils.formatNumber(+n.lastYearValue)}</TableCell>

                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={5} className={cls.tC} scope="row" padding="none">
                                No data available
                              </TableCell>
                            </TableRow>
                          )
                        }
                      </TableBody>
                    </Table>
                  </Grid>
                  : null}
              </Grid>
              {/*********************************************************** FOOTER *****************************************************************/}
            </Grid>
          </TableContainer>
          {/* FOOTER SECTION - Pagination (hidden when search/varegruppe has a value) */}
          {page.content.length > 0 && !methods.watch('search') ?
            <Grid container height={"39px"} alignItems="center" justifyContent='center'
              className={cls.bb} rowSpacing={0} columnSpacing={0}>
              <Grid>
                <Pagination sx={{
                  color: 'white',
                  "& .Mui-selected": {
                    backgroundColor: "#fff"
                  }
                }}
                  count={defaultPageCount}
                  onChange={(e, value) => pagechange(e, value)}
                  onKeyUp={(e) => pagechange(e)}
                  page={Math.max(1, (methods.getValues('page') || 0) + 1)}
                  renderItem={(item) => (
                    <PaginationItem sx={{ fontSize: '1.2em', }}
                      {...item}
                    />
                  )}
                />
              </Grid>
            </Grid>
            : null}</Paper>
      </form>
    </FormProvider >
  );
};
// Exporting the NV05Form component
export default NV05List;